export const LocalStorageBoolean = {
  set(key: string, value: boolean): void {
    localStorage.setItem(key, value ? 'true' : 'false');
  },

  get(key: string): boolean {
    return (localStorage.getItem(key) ?? 'false') === 'true';
  },

  remove(key: string): void {
    localStorage.removeItem(key);
  },
};
